<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.Role">Role</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">

        <span class="select-quarter-width">
          <mat-form-field matTooltip="Role Name">
            <mat-label i18n="@@type.Role.name">Name</mat-label>
            <input matInput formControlName="name" placeholder="Filter" [(ngModel)]="nameFilter" name="nameFilter"
              #nameFilterInput placeholder="Name" class="field-threequarter-width">
          </mat-form-field>
        </span>

        <span><button class="action-button" mat-raised-button color="primary" (click)="clearFilters()"
            i18n="@@actions.clearFilters">Clear
            Filters</button></span>

      </div>
    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc" matSortActive="name"
          matSortDisableClear cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="name">
            <mat-header-cell [crud-column-header]="columns.column('name')" *matHeaderCellDef mat-sort-header cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.Role.name"> Name </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element"> {{element.name}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="description">
            <mat-header-cell [crud-column-header]="columns.column('description')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.Role.description"> Description </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element"> {{element.description}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ownPrivileges">
            <mat-header-cell [crud-column-header]="columns.column('ownPrivileges')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Role.ownPrivileges"> Privileges (direct) </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{isDynamicPrivilegeRole(element) ? '(Dynamic)' : element.ownPrivileges.length}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="allPrivileges">
            <mat-header-cell [crud-column-header]="columns.column('allPrivileges')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Role.allPrivileges"> Privileges (all) </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{isDynamicPrivilegeRole(element) ? '(Dynamic)' : element.allPrivileges.length}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nestedRoles">
            <mat-header-cell [crud-column-header]="columns.column('nestedRoles')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Role.nestedRoles"> Included Roles (direct) </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{isDynamicPrivilegeRole(element) ? '(Dynamic)' : element.nestedRoles.length}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="allRoles">
            <mat-header-cell [crud-column-header]="columns.column('allRoles')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Role.allRoles"> Included Roles (all) </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{isDynamicPrivilegeRole(element) ? '(Dynamic)' : element.allRoles.length}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit"
                id="actions.edit">Edit</button>
              <button class="action-button" *ngIf="allowsView(element)" mat-raised-button color="primary"
                [routerLink]="viewRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.view"
                id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary"
        [routerLink]="createRoute()" [queryParams]="createRouteQueryParams()" i18n="@@actions.create"
        id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>
